import script from "./InvoiceMonthlyCustomerWorkbench.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceMonthlyCustomerWorkbench.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceMonthlyCustomerWorkbench.vue?vue&type=style&index=0&id=23887307&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23887307"]])

export default __exports__